export const ManGender = () => {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M30.7266 4.21875H21.8672C21.7512 4.21875 21.6562 4.31367 21.6562 4.42969V6.39844C21.6562 6.51445 21.7512 6.60938 21.8672 6.60938H27.5063L20.4996 13.616C18.7418 12.2625 16.5973 11.5312 14.3438 11.5312C11.6402 11.5312 9.09492 12.5859 7.18594 14.4984C5.27695 16.4109 4.21875 18.9527 4.21875 21.6562C4.21875 24.3598 5.27344 26.9051 7.18594 28.8141C9.09492 30.7266 11.6402 31.7812 14.3438 31.7812C17.0473 31.7812 19.5926 30.7266 21.5016 28.8141C23.4141 26.9051 24.4688 24.3598 24.4688 21.6562C24.4688 19.4027 23.7375 17.2652 22.3875 15.5074L29.3906 8.5043V14.1328C29.3906 14.2488 29.4855 14.3438 29.6016 14.3438H31.5703C31.6863 14.3438 31.7812 14.2488 31.7812 14.1328V5.27344C31.7812 4.69336 31.3066 4.21875 30.7266 4.21875ZM14.3438 29.1094C10.234 29.1094 6.89062 25.766 6.89062 21.6562C6.89062 17.5465 10.234 14.2031 14.3438 14.2031C18.4535 14.2031 21.7969 17.5465 21.7969 21.6562C21.7969 25.766 18.4535 29.1094 14.3438 29.1094Z'
        fill='white'
        fillOpacity='0.45'
      />
    </svg>
  );
};
